import { SET_USER } from "../constants/mutations.type";

export default {
  [SET_USER](state, payload) {
    state.user = payload;
  }
};
